/*************************************************/
/* LANGUAGE                                      */
/*************************************************/

export function language() {
    const languageSelectorSelector = ".language-selector";
    const visibleClass = "language-selector--visible";

    const toggleLanguageSelector = function(languageSelector, forceClose = false) {
        if (languageSelector != null) {
            if (forceClose) {
                languageSelector.classList.remove(visibleClass);
            } else if (!languageSelector.classList.contains(visibleClass)) {
                languageSelector.classList.add(visibleClass);
            } else {
                languageSelector.classList.remove(visibleClass);
            }
        }
    };

    const init = function() {
        const languageSelectors = document.querySelectorAll(languageSelectorSelector);

        languageSelectors.forEach(languageSelector => {
            const current = languageSelector.querySelector('.language-selector__current');
            if (current) {
                current.addEventListener('click', e => {
                    const languageSelectorElement = e.target.closest(languageSelectorSelector);
                    toggleLanguageSelector(languageSelectorElement);
                });
            }
        });

        document.addEventListener('click', e => {
            if (!e.target.closest(languageSelectorSelector)) {
                languageSelectors.forEach(languageSelector => toggleLanguageSelector(languageSelector, true));
            }
        });
    };

    init();
}
